/**
 * Utility functions for debugging issues between environments
 */

/**
 * Helper to safely log debug information only when explicitly enabled
 * Prevents console logs from being left in production code
 */
export function debugLog(...args: unknown[]) {
  if (typeof window !== "undefined") {
    console.log("[DEBUG]", ...args);
  }
}

/**
 * Creates a debug report with important browser and state information
 * to help diagnose environment-specific issues
 */
export function createEnvironmentReport(searchParams: unknown) {
  const report = {
    screenSize:
      typeof window !== "undefined"
        ? {
            height: window.innerHeight,
            width: window.innerWidth,
          }
        : "server-side",
    searchParams,
    timestamp: new Date().toISOString(),
    url: typeof window !== "undefined" ? window.location.href : "server-side",
    userAgent:
      typeof window !== "undefined"
        ? window.navigator.userAgent
        : "server-side",
  };

  debugLog("Environment Debug Report:", report);
  return report;
}
